"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADMIN_ATTENTION_ORDER = exports.ADMIN_CHANGE_EVENT_TYPES = exports.RECENT_ADMIN_CHANGES_LIMIT = exports.HOLIDAY_CHECK_FROM_MONTH = exports.ANONYMISE_WITHIN_DAYS = exports.INVITE_LINK_DAYS = exports.INVITE_UNACCEPTED_DAYS = void 0;
exports.holidayYearToCheck = holidayYearToCheck;
exports.inviteSentAt = inviteSentAt;
exports.isInviteUnaccepted = isInviteUnaccepted;
exports.unacceptedInviteExpiresBefore = unacceptedInviteExpiresBefore;
// Admin redesign 2026-11-02 (brief items 3 and 4): the Admin Overview (the health board) and the
// red counts in the Admin menu. Every number is counted live from the records and the event log
// when it is asked for, never stored (non-negotiable #10).
/** "Invitations not accepted after 3 days." */
exports.INVITE_UNACCEPTED_DAYS = 3;
/** How long an invite link lasts; a resend starts it again (`INVITE_TOKEN_MS` on the server). */
exports.INVITE_LINK_DAYS = 7;
/** "Records due for anonymising within 7 days." */
exports.ANONYMISE_WITHIN_DAYS = 7;
/** From 1 October (Asia/Dhaka), next year's holidays should be on every calendar. */
exports.HOLIDAY_CHECK_FROM_MONTH = 10;
exports.RECENT_ADMIN_CHANGES_LIMIT = 8;
const DAY_MS = 24 * 60 * 60 * 1000;
/**
 * The settings and module changes the Overview's "Recent changes" lists, from the event log.
 * Written out in full rather than as prefixes, so the read uses the `(event_type, occurred_at)` index.
 */
exports.ADMIN_CHANGE_EVENT_TYPES = [
    'config.approval_chain_created',
    'config.approval_chain_updated',
    'config.career_site_updated',
    'config.custom_field_updated',
    'config.fx_rates_updated',
    'config.kit_created',
    'config.kit_updated',
    'config.name_equivalences_updated',
    'config.pipeline_created',
    'config.pipeline_updated',
    'config.plan_created',
    'config.plan_updated',
    'config.reasons_updated',
    'config.retention_updated',
    'config.rubric_created',
    'config.rubric_updated',
    'config.sources_updated',
    'config.system_updated',
    'config.tags_updated',
    'settings.module_toggled',
    'calendar.created',
    'calendar.updated',
    'calendar.archived',
    'calendar.holiday_added',
    'calendar.holiday_removed',
    'resource.created',
    'resource.updated',
    'resource.archived',
    // A room put back with Undo (Rooms, 2026-11-02): `room`, payloadAfter `{ name }`.
    'resource.restored',
    'offer_letter.created',
    'offer_letter.updated',
    'template.created',
    'template.updated',
    'tool_name.added',
    'tool_name.hidden',
    'tool_name.merged',
    'tool_name.restored',
    'staff_list.replaced',
    'metric_dictionary.updated',
    'role.created',
    'role.updated',
    'role.deleted',
    'role.field_rule_changed',
    'role.transition_rule_changed',
    'user.invited',
];
/**
 * The year whose holidays should already be on every calendar, or null before 1 October.
 * `today` is the date in Asia/Dhaka, `yyyy-mm-dd`.
 */
function holidayYearToCheck(today) {
    const year = Number(today.slice(0, 4));
    const month = Number(today.slice(5, 7));
    if (!Number.isInteger(year) || !Number.isInteger(month))
        return null;
    return month >= exports.HOLIDAY_CHECK_FROM_MONTH ? year + 1 : null;
}
/** When a pending invite was last sent: its link runs `INVITE_LINK_DAYS` from the send. */
function inviteSentAt(expiresAt) {
    return new Date(expiresAt.getTime() - exports.INVITE_LINK_DAYS * DAY_MS);
}
/**
 * A pending invite last sent at least `INVITE_UNACCEPTED_DAYS` ago. An expired link still counts:
 * nobody accepted it, and it waits until somebody sends it again or cancels it.
 */
function isInviteUnaccepted(expiresAt, now) {
    return now.getTime() - inviteSentAt(expiresAt).getTime() >= exports.INVITE_UNACCEPTED_DAYS * DAY_MS;
}
/** The latest `expiresAt` a pending invite can have and still count as unaccepted. */
function unacceptedInviteExpiresBefore(now) {
    return new Date(now.getTime() + (exports.INVITE_LINK_DAYS - exports.INVITE_UNACCEPTED_DAYS) * DAY_MS);
}
/** The order the lines are listed in. */
exports.ADMIN_ATTENTION_ORDER = [
    'failed_emails_today',
    'invites_unaccepted',
    'holidays_missing',
    'anonymising_soon',
    'starter_templates',
];
//# sourceMappingURL=admin-overview.js.map